const StepDataDto = {
	contractType: "",
	createContractType: "",
	created: null,
	createdDate: "",
	createdName: "",
	createdOrgName: "",
	createdRankName: "",
	description: "",
	id: null,
	isActive: false,
	isAddHistory: false,
	isAddQRCode: false,
	isAddWaterMark: false,
	isApprove: true,
	isAttachFilePDF: false,
	isAuthorizedApproval: false,
	isAutoSendMail: false,
	isBack: false,
	isChangeProcess: false,
	isChangeStatus: false,
	isConsult: false,
	isCreateContract: false,
	isCreateOTPLink: false,
	isCreateOfficalDispath: false,
	isCreateReport: false,
	isCreateTFSTask: false,
	isDeny: false,
	isEdit: false,
	isEditForm: false,
	isExamine: false,
	isExportPDF: false,
	isGoingBackToCreator: false,
	isLockFile: false,
	allowEditMainDoc: false,
	isManageStamp: false,
	isProcessRecover: false,
	isProcessSaveDoc: false,
	isRecall: false,
	isRequestModify: false,
	isRequiredSignature: false,
	disableXmlSign: false,
	disableEditSignature: false,
	isRequiredOpinionSignature: false,
	isSaveDoc: false,
	isSendMail: false,
	isSendMailCTP: false,
	isRecallRequest: true,
	editFieldDataType1: false,
	isSendMailCustomer: false,
	isSendNoticePriority: false,
	isSendOTP: false,
	listCustomer: [],
	mailTemplate: null,
	mailTemplateCTP: null,
	mailTemplateCustomer: null,
	modified: null,
	modifiedDate: "",
	modifiedName: "",
	optionDeny: 0,
	organizationCode: "",
	organizationName: "",
	otpSign: false,
	opinionOtpSign: false,
	receiveNoti: null,
	processData: null,
	processOfContract: "string",
	processingTerm: 0,
	processingTermDay: 1,
	processingTermTime: "",
	rank: null,
	rankCode: "",
	rankName: "",
	requestData: { id: null },
	roundNumber: 1,
	sendNoticePriorityType: "",
	signConfig: "",
	opinionSignConfig: "",
	stepDataCode: "",
	stepDataName: "",
	stepInProcess: null,
	stepOrder: null,
	timeActive: "",
	userInfos: [],
	userInfosMailTemplateCTP: [],
};

export default StepDataDto;
